import { ILogModel } from "../interfaces/ILogModel";
import { ISolicitudChofer, ISolicitudVehiculoModel } from "../interfaces/solicitud/ISolicitudVehiculoModel";
import { ChoferModel } from "./ChoferModel";
import { DocumentacionRequeridaModel } from "./DocumentacionRequeridaModel";

export class VehiculoDialogModel {
    vehiculo: VehiculoModel;
    documentacionRequerida: DocumentacionRequeridaModel[];
    enableEdit: boolean;
    
    constructor(){
        this.vehiculo = new VehiculoModel();
        this.documentacionRequerida = new Array<DocumentacionRequeridaModel>();
        this.enableEdit = true;
    }
}

export class VehiculoModel implements ISolicitudVehiculoModel {    
    idSolicitud: number;
    codigoSolicitud: string;
    idSolicitudVehiculo: number;

    tipoVehiculo: string;

    marca : string;
    
    anio? : number;
    
    combustible : string;
    
    placa : string;
    
    color : string;
    
    tarjetaPropiedad : string;
    
    soat : string;
    
    modelo : string;
    
    solicitudChofer : ISolicitudChofer;

    idEstado: number;
    estado: string;
    documentos: Array<DocumentacionRequeridaModel>;
    documentosRequeridos: Array<DocumentacionRequeridaModel>;
    comentarios: string;
    
    documentosRevisados: number;
    enableEdit: boolean;
    logs: ILogModel[] = [];
    completado: boolean;
    
    constructor(){
        this.idSolicitud = 0;
        this.codigoSolicitud = '';
        this.idSolicitudVehiculo = 0;
        this.tipoVehiculo = '';
        this.marca = '';
        this.anio = new Date().getFullYear();
        this.combustible = '';
        this.placa = '';
        this.color = '';
        this.tarjetaPropiedad = '';
        this.soat = '';
        this.modelo = '';
        this.solicitudChofer = new ChoferModel();
        this.idEstado = 0;
        this.estado = '';
        this.documentos = new Array<DocumentacionRequeridaModel>();
        this.documentosRequeridos = new Array<DocumentacionRequeridaModel>();
        this.comentarios = '';
        this.enableEdit = true;      
        this.documentosRevisados = 0;  
        this.completado = false;
    }

    EsValido(): boolean {
        return (
        this.marca !== '' &&
        // this._anio !== '' &&
        this.combustible !== '' &&
        this.placa !== '' &&
        this.color !== '' &&
        this.tarjetaPropiedad !== '' &&
        this.soat !== '' &&
        this.placa !== '' &&
        this.modelo !== '' &&
        this.solicitudChofer.EsValido());
    }
}